// extracted by mini-css-extract-plugin
module.exports = {"root":"PendingPaymentAlert_root__AUXQK","buttons":"PendingPaymentAlert_buttons__3Hk2U"};